import React from "react";
import "../styles/EmptyChannelMessage.css"; 
const EmptyChannelMessage = () => {
  return (
    <div className="str-chat__main-panel str-chat__empty-channel">
      <div className="empty-channel-content">
        <div className="chat-icon">
          <span role="img" aria-label="chat" className="chat-icon-image">
            💬
          </span>
        </div>
        <p className="str-chat__empty-channel-text">
          No chats yet started. Please search or select a user to chat with.
        </p>
      </div>
    </div>
  );
};

export default EmptyChannelMessage;